import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Result } from 'antd';

import styled from 'styled-components';

import { addModelLog } from '@libs/NwLogs';

import { useStateValue } from '@contexts/StateProvider';

import { useContact } from '@hooks/API/Contact/UseContact';

import ModelDetailsBooksWrapper from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/ModelDetailsBooksWrapper';
import ModelDetailsCalendar from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsCalendar';

import Comments from '@components/Comments/Comments';
import ModelDetailsMobileTabs from '@components/ContactDetails/ModelDetails/ModelDetailsMobile/ModelDetailsMobileTabs';
import ContactDetailsDocuments from '@components/ContactDetailsDocuments/ContactDetailsDocuments';
import ContactDetailsNotes from '@components/ContactDetailsNotes/ContactDetailsNotes';
import FlexContainer from '@components/Gui/FlexContainer';
import { Loading } from '@components/Gui/Loading';
import NwDivider from '@components/Gui/NwDivider';
import NwIcon from '@components/Gui/NwIcon';
import ModelAgenciesCardMobile from '@components/ModelAgencies/ModelAgenciesCardMobile';

import ModelDetailsMobilePage from './ModelDetailsMobile/ModelDetailsMobilePage';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/**
 * La barra dei tab è `fixed`, quindi il suo offset dipende da cosa la precede:
 * nel drawer coincide con il bordo alto del body, nella pagina intera con il
 * bordo basso dell'header applicativo (104px su mobile).
 * Il padding del contenuto copre l'altezza della barra (61px) più lo scarto
 * tra il bordo alto del Wrapper e la barra stessa.
 */
const TABS_LAYOUT = {
    drawer: { top: '9.9rem', contentPaddingTop: '3.8rem' },
    page: { top: '6.5rem', contentPaddingTop: '3.2rem' },
};

const Wrapper = styled.div`
    background: white;
    padding-top: ${(props) => props.$contentPaddingTop};

    .container {
        position: relative;
        padding: 0.5rem 1rem;
    }

    .back-models {
        font-size: 0.8rem;
        cursor: pointer;
    }
`;

const Label = styled.div`
    font-size: 1.6rem;
`;

const ModelDetailsIndexMobile = ({ isDrawer, modelID, selectedTab }) => {
    const [{ areaContext }] = useStateValue();
    const [activeTab, setActiveTab] = useState(selectedTab || 'profile');
    const navigate = useNavigate();
    const [contactCalendarStyle, setContactCalendarStyle] = useState('agenda');

    const { data: currentContact } = useContact(modelID);
    const tabsLayout = isDrawer ? TABS_LAYOUT.drawer : TABS_LAYOUT.page;

    useEffect(() => {
        currentContact &&
            currentContact.NetworkAgencies &&
            !currentContact.NetworkAgencies[0].StorageBooking &&
            addModelLog(currentContact, areaContext.area);

    }, [currentContact]);

    const handleChangeView = (viewType) => () => {
        setActiveTab(viewType);
    };

    const handleBackToModels = () => {
        navigate('/models');
    };

    if (!currentContact) {
        return (
            <div style={{ marginTop: '4rem' }}>
                <Loading textBlack />
            </div>
        );
    }

    return (
        <Wrapper $contentPaddingTop={tabsLayout.contentPaddingTop}>
            <ModelDetailsMobileTabs
                viewType={activeTab}
                topOffset={tabsLayout.top}
                onViewModelProfile={handleChangeView('profile')}
                onViewCalendar={handleChangeView('calendar')}
                onViewModelBooks={handleChangeView('books')}
                onViewFiles={handleChangeView('files')}
                onViewComments={handleChangeView('comments')}
                onViewAgencies={handleChangeView('agencies')}
                //onViewStatement={handleChangeView('statement')}
            />
            {currentContact && (
                <>
                    {currentContact.NetworkAgencies[0].StorageBooking ? (
                        <Result title="This model has been archived" />
                    ) : (
                        <div className="container">
                            {/* {activeTab !== 'profile' && !isDrawer && (
                                <FlexContainer mg="16px 0 8px" column alignItems="center" justifyContent="center">
                                    <FlexContainer
                                        className="back-models"
                                        alignItems="center"
                                        onClick={handleBackToModels}
                                    >
                                        <NwIcon icon={byPrefixAndName.fasl['arrow-left']}></NwIcon>
                                        &nbsp;back to models list
                                    </FlexContainer>
                                    <Label>{`${currentContact.Name} ${currentContact.Surname}`}</Label>
                                </FlexContainer>
                            )} */}
                            {(() => {
                                switch (activeTab) {
                                    case 'profile':
                                        return <ModelDetailsMobilePage isDrawer currentContact={currentContact} />;
                                    case 'calendar':
                                        return (
                                            <ModelDetailsCalendar
                                                isMobileDrawer={isDrawer}
                                                idmodel={currentContact.ID}
                                                calendarStyle={contactCalendarStyle}
                                                onChangeCalendarStyle={setContactCalendarStyle}
                                            />
                                        );
                                    case 'books':
                                        return (
                                            <ModelDetailsBooksWrapper
                                                contactID={currentContact.ID}
                                                modelPlaylists={currentContact.Playlists}
                                            />
                                        );
                                    case 'files':
                                        return (
                                            <ContactDetailsDocuments
                                                //isInCardTab
                                                currentContact={currentContact}
                                            />
                                        );
                                    case 'comments':
                                        return (
                                            <>
                                                <NwDivider>Comments</NwDivider>
                                                <Comments
                                                    api="ContactID"
                                                    drawerMode
                                                    isInCardTab
                                                    contactId={currentContact.ID}
                                                    ID={currentContact.ID}
                                                    comments={currentContact.Comments}
                                                />
                                                <NwDivider>Notes</NwDivider>
                                                <ContactDetailsNotes
                                                    isInCardTab
                                                    currentContact={currentContact}
                                                    afterNotesCreation={() => {}}
                                                />
                                            </>
                                        );
                                    case 'agencies':
                                        return (
                                            <ModelAgenciesCardMobile
                                                contactID={currentContact.ID}
                                            />
                                        );
                                    case 'statement':
                                        return <div />;
                                    default:
                                        return null;
                                }
                            })()}
                        </div>
                    )}
                </>
            )}
        </Wrapper>
    );
};

export default ModelDetailsIndexMobile;
